module.exports = __webpack_public_path__ + "static/media/greymask.9c000521.svg";